import {
  Box,
  IconButton,
  Slide,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";

import type { JSX } from "react";

export const PANEL_WIDTH = 300;

type PanelTransitionState = "entering" | "entered" | "exiting";

interface Props {
  title: string;
  description?: string;
  children: JSX.Element;
  open: boolean;
  doClose: () => void;
  topRight?: JSX.Element;
}

export const PanelLayout = ({
  title,
  description,
  children,
  open,
  doClose,
  topRight,
}: Props) => {
  const theme = useTheme();
  const [transitionState, setTransitionState] =
    useState<PanelTransitionState>("entering");

  return (
    <Slide
      in={open}
      direction="left"
      mountOnEnter
      unmountOnExit
      onEnter={() => {
        setTransitionState("entering");
      }}
      onEntered={() => {
        setTransitionState("entered");
      }}
      onExit={() => {
        setTransitionState("exiting");
      }}
    >
      <Box
        data-testid="search-panel"
        data-transition-state={transitionState}
        sx={{
          paddingX: 3,
          paddingY: 2,

          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 2,

          backgroundColor: "#ffffff",
          display: "flex",
          flexDirection: "column",
          overflow: "auto",
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
          spacing={1}
        >
          <IconButton
            data-testid="EditInput-close"
            onClick={() => {
              doClose();
            }}
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h2">{title}</Typography>
          {topRight ?? null}
        </Stack>
        {description ? (
          <Typography
            variant="body1"
            sx={{
              color: theme.palette.text.secondary,
            }}
          >
            {description}
          </Typography>
        ) : null}
        <Box sx={{ minHeight: "0px" }}>{children}</Box>
      </Box>
    </Slide>
  );
};
